import { render, staticRenderFns } from "./VVote.vue?vue&type=template&id=2bd23965&scoped=true"
import script from "./VVote.vue?vue&type=script&lang=ts"
export * from "./VVote.vue?vue&type=script&lang=ts"
import style0 from "./VVote.vue?vue&type=style&index=0&id=2bd23965&prod&lang=scss&scoped=true"
import style1 from "./VVote.vue?vue&type=style&index=1&id=2bd23965&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd23965",
  null
  
)

export default component.exports